import { Badge } from "@/components/ui";
import {
  ACCESS_PROGRAM_GROUP,
  CMS_ACCESS_ENROLLMENT_FLAG,
  programTrackDisplayName,
} from "@/constants/AccessProgram";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { useEncounter } from "@/network/useEncounter";
import { ClipboardList } from "lucide-react";

interface EnrollmentVisitChipProps {
  patientId: string;
  encounterId?: string;
}

export const EnrollmentVisitChip = ({
  patientId,
  encounterId,
}: EnrollmentVisitChipProps) => {
  const { data: accessFlag } = useConfigCatFeatureFlag(
    CMS_ACCESS_ENROLLMENT_FLAG,
  );
  const { data: encounter } = useEncounter(encounterId, patientId);
  const program = encounter?.program;

  if (
    accessFlag !== true ||
    !encounterId ||
    program?.group !== ACCESS_PROGRAM_GROUP
  ) {
    return null;
  }

  return (
    <Badge
      className="bg-access text-access"
      data-testid="access-enrollment-visit-chip"
    >
      <ClipboardList />
      ACCESS enrollment visit · {programTrackDisplayName(program.type)}
    </Badge>
  );
};
